/**
 * Resolves a safe "back" destination that avoids history loops
 * (e.g. /crm ↔ /crm/new when using navigate(-1)).
 */

const EXACT_PARENTS: Record<string, string> = {
  '/crm': '/',
  '/crm/new': '/crm',
  '/work-orders': '/',
  '/work-orders/new': '/work-orders',
  '/assets': '/',
  '/assets/new': '/assets',
  '/assets/scan': '/assets',
  '/assets/create-qr': '/assets',
  '/maintenance': '/',
  '/maintenance/new': '/maintenance',
  '/property-tasks': '/',
  '/scheduling': '/',
  '/scheduling/new-task': '/scheduling',
  '/gps': '/',
  '/analytics': '/',
  '/analytics/monthly-report': '/analytics',
  '/analytics/performance-report': '/analytics',
  '/settings': '/',
  '/notifications': '/',
  '/chat': '/',
  '/company': '/',
  '/company/chat': '/company',
  '/company/invite': '/company',
  '/user-management': '/settings',
  '/add-supervisor': '/user-management',
  '/add-technician': '/user-management',
  '/subscription': '/',
  '/subscription/manage': '/subscription',
  '/financials': '/',
  '/financials/transactions': '/financials',
  '/financials/chart-of-accounts': '/financials',
  '/financials/invoicing': '/financials',
  '/financials/invoicing/new': '/financials/invoicing',
  '/financials/purchase-orders': '/financials',
  '/multi-tenancy-guide': '/',
  '/financial-app-guide': '/',
  '/qr-scanner-help': '/assets/scan',
  '/setup/tenant': '/',
  '/portal': '/',
};

export function getBackDestination(pathname: string): string {
  const exact = EXACT_PARENTS[pathname];
  if (exact) return exact;

  if (pathname.startsWith('/admin/') && pathname !== '/admin/dashboard') {
    return '/admin/dashboard';
  }

  if (/^\/work-orders\/[^/]+\/photos$/.test(pathname)) {
    return pathname.replace(/\/photos$/, '');
  }

  if (/^\/work-orders\/[^/]+$/.test(pathname)) {
    return '/work-orders';
  }

  if (/^\/assets\/[^/]+$/.test(pathname)) {
    return '/assets';
  }

  if (pathname.startsWith('/financials/')) {
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length > 2) {
      return `/${segments.slice(0, 2).join('/')}`;
    }
    return '/financials';
  }

  if (pathname.startsWith('/analytics/')) {
    return '/analytics';
  }

  if (pathname.startsWith('/company/')) {
    return '/company';
  }

  return '/';
}